import React from 'react';
import {useTranslation} from 'react-i18next';

import {GuideMedia} from '../../../guides/GuideMedia';
import {StepMedia} from './StepMedia';
import usefulDashboardAnim from '../../../images/onboarding/setup-useful-dashboard.webp';
import memoryAddedAnim from '../../../images/onboarding/setup-memory-added.webp';
import portalInvitedAnim from '../../../images/onboarding/setup-portal-invited.webp';
import mediaPlanSyncedAnim from '../../../images/onboarding/setup-media-plan-synced.webp';
import usefulDashboardPoster from '../../../images/onboarding/setup-useful-dashboard.poster.webp';
import memoryAddedPoster from '../../../images/onboarding/setup-memory-added.poster.webp';
import portalInvitedPoster from '../../../images/onboarding/setup-portal-invited.poster.webp';
import mediaPlanSyncedPoster from '../../../images/onboarding/setup-media-plan-synced.poster.webp';

/**
 * Las animaciones que ya viajan en el bundle (las del drawer «Tus primeros pasos»), por clave de
 * tarea. El backend manda `media: {kind: 'animation', url: null}` cuando la tarea usa una de éstas
 * (contrato §4); con `url`, es una del Centro de Ayuda y se usa esa.
 *
 * `setup-useful-dashboard` es el asistente de «Nueva línea» (elegir las cuentas y «Siguiente»): por
 * eso es la de crear una línea.
 */
export const BUNDLED_ANIMATIONS = {
    line_created: {src: usefulDashboardAnim, poster: usefulDashboardPoster},
    memory_added: {src: memoryAddedAnim, poster: memoryAddedPoster},
    portal_invited: {src: portalInvitedAnim, poster: portalInvitedPoster},
    media_plan_synced: {src: mediaPlanSyncedAnim, poster: mediaPlanSyncedPoster},
};

/** `true` si la tarea tiene algo que mostrar (el layout de la tarea abierta deja o no la columna). */
export function hasTaskMedia(task) {
    const media = task && task.media;
    if (!media) return false;
    if (media.kind === 'video') return Boolean(media.url);
    return Boolean(media.url || BUNDLED_ANIMATIONS[task.key]);
}

/**
 * El video o la animación de una tarea. Un video es siempre un embed (YouTube, Vimeo o Loom) y lo
 * dibuja la galería de las guías, que ya traduce los links «para compartir» y filtra dominios.
 */
export function TaskMedia({task, title}) {
    const {t} = useTranslation();
    if (!hasTaskMedia(task)) return null;
    const {media} = task;

    if (media.kind === 'video') {
        const caption = media.seconds
            ? t('learn_dashbo.task.video_caption', {seconds: media.seconds})
            : '';
        return (
            <div className="ld-video">
                <GuideMedia items={[{kind: 'embed', url: media.url, caption}]}/>
            </div>
        );
    }

    // El póster va con SU animación: una del Centro de Ayuda sin póster no toma el de la del bundle.
    const bundled = BUNDLED_ANIMATIONS[task.key] || {};
    const src = media.url || bundled.src;
    const poster = media.url ? media.posterUrl : bundled.poster;
    return <StepMedia src={src} poster={poster} title={title}/>;
}
